import { MatDateFormats } from "@angular/material/core";

export interface DateTimeFormats extends MatDateFormats {
    parse: MatDateFormats["parse"] & {
        dateTimeInput: string;
        timeInput: string;
        timeWithSecondsInput: string;
        dateInputFns: string;
    };
}

// the subtitle of a notification, e.g. "qui, 15 de out de 2026 às 14:30"
export const NOTIFICATION_TIME_FORMAT = "EEEEEE, dd 'de' MMM 'de' yyyy 'às' HH:mm";

export const DD_MM_YYYY_FORMATS: MatDateFormats = {
    parse: {
        dateInput: "dd/MM/yyyy",
    },
    display: {
        dateInput: "dd/MM/yyyy",
        monthYearLabel: "MMM yyyy",
        dateA11yLabel: "PPP",
        monthYearA11yLabel: "MMMM yyyy",
    },
};

export const MM_YYYY_FORMATS: MatDateFormats = {
    parse: {
        dateInput: "MM/yyyy",
    },
    display: {
        dateInput: "MM/yyyy",
        monthYearLabel: "MMM yyyy",
        dateA11yLabel: "PPP",
        monthYearA11yLabel: "MMMM yyyy",
    },
};

export const MONTH_YEAR_FORMATS: MatDateFormats = {
    parse: {
        dateInput: "dd/MM/yyyy",
    },
    display: {
        dateInput: "MMMM yyyy",
        monthYearLabel: "MMM yyyy",
        dateA11yLabel: "PPP",
        monthYearA11yLabel: "MMMM yyyy",
    },
};

export const DATE_TIME_FORMATS: DateTimeFormats = {
    parse: {
        dateInput: "dd/MM/yyyy",
        dateTimeInput: "dd/MM/yyyy HH:mm",
        timeInput: "HH:mm",
        timeWithSecondsInput: "HH:mm:ss",
        dateInputFns: "dd/MM/yyyy",
    },
    display: {
        dateInput: "dd/MM/yyyy",
        monthYearLabel: "MMM yyyy",
        dateA11yLabel: "PPP",
        monthYearA11yLabel: "MMMM yyyy",
    },
};
